export default "__VITE_ASSET__BoEZsZKU__"